import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span ...attributes class=\"fly-responsive-tabs__item-label text-bold-placeholder overflow-hidden overflow-ellipsis\" data-text-bold-placeholder={{@label}}>\n  {{@label}}\n</span>", {
  moduleName: "@customerio/fly-components/components/fly-responsive-tabs/label.hbs"
});